import type AttachmentWellHost from 'owa-calendar-meeting-forms-common-store/lib/store/schema/AttachmentWellHost';
import createAttachments from 'owa-calendar-compose-form-store/lib/actions/createAttachments';
import getEventClientItemId from 'owa-calendar-compose-form-store/lib/utils/getEventClientItemId';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import type { AttachmentFileList, CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { onAttachmentCreated } from 'owa-calendar-compose-form-actions';

export default function (
    fileList: AttachmentFileList,
    properties: CreateAttachmentsProperties,
    formId: string
) {
    createAttachments(
        getComposeStore(formId).uiState as AttachmentWellHost,
        getEventClientItemId(),
        fileList,
        properties,
        null /* infoBar */,
        null /* onFinish */,
        (itemId, attachmentId, attachment) => onAttachmentCreated(attachmentId, attachment)
    );
}
